import React, { useState } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";

const CreateAlbumModal = ({ albums, onSubmit, onCancel }) => {
  const [title, setTitle] = useState("");
  const [parentId, setParentId] = useState(null);
  const [showAlert, setShowAlert] = useState();

  const handleSubmit = () => {
    if (title.trim() === "") {
      setShowAlert(true);
      return;
    }
    // Assuming onSubmit receives title and parentId
    onSubmit({ title, parentId });
    // Clear inputs after submission
    setTitle("");
    setParentId(null);
    setShowAlert(false);
  };

  return (
    <Modal show={true} onHide={onCancel}>
      <Modal.Header closeButton>
        <Modal.Title>Create Album</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {showAlert && <Alert variant="danger">Title is required.</Alert>}
        <Form>
          <Form.Group controlId="formTitle">
            <Form.Label>Title</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter title"
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
                setShowAlert(e.target.value.trim() === "");
              }}
            />
          </Form.Group>
          <Form.Group controlId="formParent">
            <Form.Label>Parent</Form.Label>
            <Form.Control
              as="select"
              value={parentId}
              onChange={(e) => setParentId(parseInt(e.target.value))}
            >
              <option value={null}>None</option>
              {albums.map((album) => (
                <option key={album.id} value={album.id}>
                  {album.title}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={title.trim() === ""}
        >
          Create
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateAlbumModal;
